import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  NvidiaShuttleLoginStepFormFieldsEnum,
  yupLanding,
} from "@ryde/utils-landings";

export const useYupLoginLandingNvidiaShuttleValidationSchema = () => {
  const { t } = useTranslation();
  const yupLoginLandingNvidiaShuttleValidationSchema = useMemo(() => {
    return {
      [NvidiaShuttleLoginStepFormFieldsEnum.Email]: yupLanding
        .string()
        .required()
        .email()
        .test("nvidia-email", t("landing.errors.emailMustBeNvidia"), value => {
          return (
            value?.endsWith("@nvidia.com") ||
            value?.endsWith("@goryde.com") || // Allow goryde.com for testing
            false
          );
        }),
    };
  }, [t]);
  return { yupLoginLandingNvidiaShuttleValidationSchema };
};
